export const MailIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00002 5.98516C0.944241 9.98833 0.999983 13.9964 0.999983 18C0.999983 19.6523 2.3477 21 3.99998 21H20C21.6523 21 23 19.6523 23 18C23 13.9958 23.0778 9.98294 22.9999 5.97961C22.9889 4.33664 21.6455 3 20 3H3.99998C2.35265 3 1.00806 4.33965 1.00002 5.98516ZM3.10657 5.55394C3.27195 5.22692 3.61203 5 3.99998 5H20C20.3879 5 20.728 5.22693 20.8934 5.55396L12 11.7793L3.10657 5.55394ZM21 7.92067V18C21 18.5477 20.5477 19 20 19H3.99998C3.45227 19 2.99998 18.5477 2.99998 18V7.92064L11.4265 13.8192C11.7709 14.0603 12.2291 14.0603 12.5735 13.8192L21 7.92067Z"
        fill="currentColor"
      />
    </svg>
  );
};
